import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { PrinterService } from '../../../services/core/printer.service';
import { UserOperationalService } from '../../../services/user-operational.service';
import { FileService } from '../../../services/core/file.service';
import { AlertifyService } from '../../../services/core/alertify.service';
import { TranslateService } from '@ngx-translate/core';
import { DateUtils } from '../../../utils/date.utils';


@Component({
  selector: 'app-preview-html-modal',
  templateUrl: './preview-html-modal.component.html',
  styleUrls: ['./preview-html-modal.component.css']
})
export class PreviewHtmlModalComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() data: any;
  @Input() title: string = '';
  @Input() fileName: string = '';
  @Input() printOnBackScreen: boolean = false;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @ViewChild('previewFrame') previewFrame!: ElementRef<HTMLIFrameElement>;

  isSearchDistrict: boolean = false;
  isDeveloperUser: boolean = false;
  loadingPdf: boolean = false;

  constructor(
    private printerservice: PrinterService,
    private userOperationalService: UserOperationalService,
    private fileService: FileService,
    private alertifyService: AlertifyService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.isDeveloperUser = this.userOperationalService.isDeveloperUser();
  }

  ngAfterViewInit(): void {
    this.loadContentToIframe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.previewFrame) {
      this.loadContentToIframe();
    }
  }

  private loadContentToIframe(): void {
    if (this.previewFrame && this.data) {
      const iframe = this.previewFrame.nativeElement;
      const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
      
      if (iframeDoc) {
        iframeDoc.open();
        iframeDoc.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <style>
                body {
                  margin: 0;
                  padding: 20px;
                  font-family: Arial, sans-serif;
                }
              </style>
            </head>
            <body>
              ${this.data}
            </body>
          </html>
        `);
        iframeDoc.close();
        
        iframe.onload = () => {
          const height = iframeDoc.body.scrollHeight;
          iframe.style.height = height + 'px';
        };
      }
    }
  }


  close() {
    this.passEntry.emit();
  }

  print() {
    if (this.printOnBackScreen) {
      this.passEntry.emit(true);
    } else {
      const iframe = this.previewFrame?.nativeElement;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.print();
      } else {
        this.printerservice.printHtmlWithPopup(this.data);
      }
    }
  }

  async exportToPdf() {
    try {
      this.loadingPdf = true;

      let fileName = `${this.fileName || this.title || 'document'}`;

      fileName = fileName.replace('.html', '');
      fileName = fileName + '_' + DateUtils.toFormat(new Date(), "YYYYMMDDHHmmss") + '.pdf';



      await this.fileService.htmlToPdf(this.data, fileName);
      this.loadingPdf = false;
      this.alertifyService.success(this.translate.instant('message.info.file-downloaded-successfully'));
    } catch (error) {
      this.loadingPdf = false;
      this.alertifyService.error(this.translate.instant('message.error.pdf-conversion-failed'));
    }
  }
}
